import { FooterLink } from "data/types";
import React from "react";
import Logo from "shared/Logo/Logo";
import { useData } from "data/data-provider";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: FooterLink[];
}

const Footer: React.FC = () => {
  const { socialItems, address, contactItems, footerItems } = useData();

  if (
    (!socialItems || socialItems.length === 0) &&
    (!address || address.length === 0) &&
    (!contactItems || contactItems.length === 0) &&
    (!footerItems || footerItems.length === 0)
  ) {
    return <div />;
  }
  return (
    <div className="nc-Footer relative py-8 border-t border-secondary-100  bg-bg-color">
      <div className="container grid grid-cols-1 gap-y-10 gap-x-4 sm:gap-x-8 md:grid-cols-1 lg:grid-cols-4 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="grid grid-cols-2 col-span-2 items-center gap-3">
            {socialItems.map((item: any, index: any) => (
              <a
                key={item.id || index}
                href={item.description}
                className="underline font-bold"
              >
                {/* {getSocialIcon(item.description ?? item.heading)} */}
                {item.heading.toUpperCase()}
              </a>
            ))}
          </div>
        </div>
        <div className="text-sm lg:ml-16 sm:ml-0">
          <h2 className="font-bold text-text-color ">Address</h2>
          <span className="mt-5 space-y-4">
            {address.map((item: any, index: any) => (
              <span key={item.id || index}>
                <span className="text-text-color break-words">
                  {item.description}
                </span>
              </span>
            ))}
          </span>
        </div>
        <div className="text-sm lg:ml-16 sm:ml-0">
          <h2 className="font-bold text-text-color ">Contact Us</h2>
          <span className="mt-5 space-y-4">
            {contactItems.map((item: any, index: any) => (
              <span key={item.id || index}>
                {item.heading ? (
                  <a
                    className="text-text-color hover:text-text-color"
                    href={item.description}
                  >
                    {item.heading}
                  </a>
                ) : (
                  <span className="text-text-color break-words">
                    {item.description}
                  </span>
                )}
              </span>
            ))}
          </span>
        </div>
        <div className="text-sm lg:ml-16 sm:ml-0">
          <h2 className="font-bold text-text-color ">Links</h2>
          <span className="mt-5 space-y-4">
            {footerItems.map((item: any, index: any) => (
              <span key={item.id || index}>
                {item.heading ? (
                  <a
                    className="text-text-color hover:text-text-color"
                    href={item.description}
                  >
                    {item.heading}
                  </a>
                ) : (
                  <span className="text-text-color break-words">
                    {item.description}
                  </span>
                )}
              </span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
